import React from "react";
import { NavLink } from "react-router-dom";
import { OnboardingSlide } from "core/models/OnboardingSlide";
import Onboarding from "ui/components/molecules/Onboarding";
import useOnboarding from "ui/hooks/useOnboarding";
import { PlanKey } from "core/models";
import { useSessionContext } from "ui/context/SessionContext";

const onboardingSlides = (plan: PlanKey): OnboardingSlide[] => [
    {
        id: 0,
        image: "./static/img/onboarding-clips.png",
        title: "Welcome to SpotOn, let's get clipping!",
        body: (
            <div>
                <p>
                    With SpotOn you&#39;ll be editing, and sharing your videos
                    easier and faster than ever. Create highlight videos from
                    your live streams in real-time, or simply upload and use
                    videos you already own.
                </p>
                {plan === "trial" && (
                    <p>
                        You&#39;re currently on our free 30-day trial period in
                        which you can test SpotOn&#39;s full functionality, no
                        strings attached.
                    </p>
                )}
            </div>
        ),
        contactUs: true,
        buttonText: "Next",
    },
    {
        id: 1,
        image: "./static/img/onboarding-clips.png",
        title: "Let's get clipping!",
        body: (
            <div>
                <p>
                    Please refer to our{" "}
                    <NavLink to="/settings/plan">plan page</NavLink> to learn
                    more about all we have got to offer. But don&#39;t stress,
                    just try SpotOn for free first and see whether it fits your
                    needs.
                </p>
                <p>
                    We hope everything speaks for itself, but just in case, we
                    have created a <NavLink to="/support">FAQ</NavLink> for the
                    most common questions, as well as more information about all
                    of our features.
                </p>
                <p>
                    If you require more help or have a specific question, you
                    can always get in touch with the team.
                </p>
            </div>
        ),
        contactUs: true,
        buttonText: "Got it!",
    },
];

const LoginOnboarding: React.FC = () => {
    const sessionContext = useSessionContext();
    const { completed, onCompleted } = useOnboarding("loginOnboarding");
    const plan = sessionContext.selectedProject?.package || "trial";
    if (completed || completed === undefined) {
        return null;
    }
    return (
        <Onboarding slides={onboardingSlides(plan)} onComplete={onCompleted} />
    );
};
export default React.memo(LoginOnboarding);
